<p8-layout-settings-page>
      <p8-layout-settings-header
        [titlePath]="[title]"
        [iconRacine]="iconTitle">
      </p8-layout-settings-header>
      <mat-card class="bel-form">
        <div class="header">
            Informations du BEL
        </div>
        <mat-card-content>
          <form [formGroup]="belForm">
            <div fxLayout="row" fxLayoutGap="2px">
              <mat-form-field appearance="outline" fxFlex="70">
                <mat-label><span class="mandatory-field">* </span>Libellé</mat-label>
                <input type="text"
                       formControlName="label"
                       matInput placeholder="libellé" data-cy="input-bel-edit-label"/>
              </mat-form-field>
              <mat-form-field appearance="outline" fxFlex="30">
                <mat-label><span class="mandatory-field">* </span>Statut du BEL</mat-label>
                <mat-select formControlName="state">
                  <ng-container *ngFor="let state of belSvc.getStates(); let i = index;">
                    <mat-option  *ngIf="state"
                               [value]="i" [attr.data-cy]="'option-bel-edit-state-' + i">{{ state }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutGap="2px">
              <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>Observations du service</mat-label>
                <textarea type="text" rows="3"
                          formControlName="observations"
                          matInput placeholder="" data-cy="txtarea-bel-edit-comment"></textarea>
              </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="2px" fxLayoutAlign="end">
              <button mat-raised-button type="button" color="primary"
                      matTooltip="Enregistrer votre bon d'élimination"
                      (click)="saveBel()"
                      [disabled]="!belForm.dirty || !belForm.valid" data-cy="btn-bl-edit-validate">
                Enregistrer vos modifications
              </button>
            </div>

          </form>
        </mat-card-content>
  </mat-card>

  <mat-card class="bel-inf-comp">
    <div class="header">Informations complémentaires</div>
    <mat-card-content *ngIf="Bel?.id">
      <app-informations-complementaires [Bel]="Bel" [edition_mode]="true" [refresh_list]="refresh_list" (refreshEvent)="refreshEvent($event)"></app-informations-complementaires>
    </mat-card-content>
  </mat-card>

  <mat-card class="bel-bordereaux">
    <div class="header">Bordereaux</div>
    <mat-card-content>
      <div class="line">
        <div class="label">
          Bordereau d'élimination :
        </div>
        <div class="actions">
          <button mat-raised-button type="button" color="primary"
                  matTooltip="Edition du bordereau pour signatures auprès des archives départementales"
                  (click)="exportPdfBel()" data-cy="btn-bordereau-elimination">
            <mat-icon>picture_as_pdf</mat-icon>
            Génération du BEL pour signatures AD et services
          </button>
          <app-upload-files
            [bordereau]="Bel"
            [type]="'BEL signé'"
            [tooltip]="'Téléversement du bordereau d\'élimination signé par les archives départementales et les services'"
            (pieceJointeEvent)="handleBelUploaded($event)">
          </app-upload-files>
          <app-download-files
            [type]="'BEL signé'"
            [file]="Bel.bordereau_elimination_object"
            [tooltip]="'Edition du bordereau d\'élimination signé par les archives départementales'">
          </app-download-files>
        </div>
      </div>
      <div class="line">
        <div class="label">
          Bordereau de destruction :
        </div>
        <div class="actions">
          <app-upload-files
            [bordereau]="Bel"
            [type]="'Bordereau de destruction'"
            [tooltip]="'Téléversement du bordereau de destruction'"
            (pieceJointeEvent)="handleBddUploaded($event)">
          </app-upload-files>
          <app-download-files
            [type]="'Bordereau de destruction'"
            [file]="Bel.bordereau_destruction_object"
            [tooltip]="'Edition du bordereau de destruction'">
          </app-download-files>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="bel-documents">
    <div class="header">Documents du BEL</div>
    <mat-card-content>
      <div *ngIf="Bel.id > 0" fxLayout="row" fxLayoutGap="2px">
        <app-documents [Bel]="Bel" (refreshEvent)="refreshEvent($event)"></app-documents>
      </div>
    </mat-card-content>
  </mat-card>
  <p8-layout-settings-footer [flexLayoutAlign]="'end'">

    <button mat-raised-button type="button"
            (click)="goList()"
            matTooltip="Retour à la liste des BEL"
            data-cy="btn-bel-edit-back">
      Retour à votre liste
    </button>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
